"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var bignumber_js_1 = require("bignumber.js");
var rxjs_1 = require("rxjs");
var hw_app_btc_1 = __importDefault(require("@ledgerhq/hw-app-btc"));
var logs_1 = require("@ledgerhq/logs");
var derivation_1 = require("./../../derivation");
var operation_1 = require("./../../operation");
var deviceAccess_1 = require("../../hw/deviceAccess");
var networks_1 = require("./networks");
var js_buildTransaction_1 = require("./js-buildTransaction");
var cache_1 = require("./cache");
var wallet_btc_1 = __importStar(require("./wallet-btc"));
var logic_1 = require("./logic");
var signOperation = function (_a) {
    var account = _a.account, deviceId = _a.deviceId, transaction = _a.transaction;
    return (0, deviceAccess_1.withDevice)(deviceId)(function (transport) {
        return rxjs_1.Observable.create(function (o) {
            function main() {
                return __awaiter(this, void 0, void 0, function () {
                    var currency, hwApp, walletAccount, txInfo, senders, recipients, fee, lockTime, unixtime, networkParams, sigHashType, segwit, hasTimestamp, initialTimestamp, perCoin, additionals, expiryHeight, hasExtraData, signature, operation;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                currency = account.currency;
                                hwApp = new hw_app_btc_1["default"]({ transport: transport, currency: currency.id });
                                walletAccount = (0, wallet_btc_1.getWalletAccount)(account);
                                (0, logs_1.log)("hw", "signTransaction ".concat(currency.id, " for account ").concat(account.id));
                                return [4 /*yield*/, (0, js_buildTransaction_1.buildTransaction)(account, transaction)];
                            case 1:
                                txInfo = _a.sent();
                                senders = new Set();
                                recipients = [];
                                fee = new bignumber_js_1.BigNumber(0);
                                // Maybe better not re-calculate these fields here, instead include them
                                // in Transaction type and set them in prepareTransaction?
                                return [4 /*yield*/, (0, cache_1.calculateFees)({
                                        account: account,
                                        transaction: transaction
                                    }).then(function (res) {
                                        senders = new Set(res.txInputs.map(function (i) { return i.address; }).filter(Boolean));
                                        recipients = res.txOutputs
                                            .filter(function (o) { return o.address && !o.isChange; })
                                            .map(function (o) { return o.address; });
                                        fee = res.fees;
                                    })];
                            case 2:
                                // Maybe better not re-calculate these fields here, instead include them
                                // in Transaction type and set them in prepareTransaction?
                                _a.sent();
                                // (legacy) Set lockTime for Komodo to enable reward claiming on UTXOs created by
                                // Ledger Live. We should only set this if the currency is Komodo and
                                // lockTime isn't already defined.
                                if (currency.id === "komodo" && lockTime === undefined) {
                                    unixtime = Math.floor(Date.now() / 1000);
                                    lockTime = unixtime - 777;
                                }
                                networkParams = (0, networks_1.getNetworkParameters)(currency.id);
                                sigHashType = networkParams.sigHash;
                                if (isNaN(sigHashType)) {
                                    throw new Error("sigHashType should not be NaN");
                                }
                                segwit = (0, derivation_1.isSegwitDerivationMode)(account.derivationMode);
                                hasTimestamp = currency.id === "peercoin";
                                initialTimestamp = hasTimestamp
                                    ? Math.floor(Date.now() / 1000)
                                    : undefined;
                                perCoin = logic_1.perCoinLogic[currency.id];
                                additionals = [currency.id];
                                if (account.derivationMode === "native_segwit") {
                                    additionals.push("bech32");
                                }
                                if (account.derivationMode === "taproot") {
                                    additionals.push("bech32m");
                                }
                                if (perCoin === null || perCoin === void 0 ? void 0 : perCoin.getAdditionals) {
                                    additionals = additionals.concat(perCoin.getAdditionals({
                                        transaction: transaction
                                    }));
                                }
                                expiryHeight = (perCoin === null || perCoin === void 0 ? void 0 : perCoin.hasExpiryHeight)
                                    ? Buffer.from([0x00, 0x00, 0x00, 0x00])
                                    : undefined;
                                hasExtraData = (perCoin === null || perCoin === void 0 ? void 0 : perCoin.hasExtraData) || false;
                                return [4 /*yield*/, wallet_btc_1["default"].signAccountTx({
                                        btc: hwApp,
                                        fromAccount: walletAccount,
                                        txInfo: txInfo,
                                        lockTime: lockTime,
                                        sigHashType: sigHashType,
                                        segwit: segwit,
                                        hasTimestamp: hasTimestamp,
                                        initialTimestamp: initialTimestamp,
                                        additionals: additionals,
                                        expiryHeight: expiryHeight,
                                        hasExtraData: hasExtraData,
                                        onDeviceSignatureGranted: function () {
                                            return o.next({
                                                type: "device-signature-granted"
                                            });
                                        },
                                        onDeviceSignatureRequested: function () {
                                            return o.next({
                                                type: "device-signature-requested"
                                            });
                                        },
                                        onDeviceStreaming: function (_a) {
                                            var progress = _a.progress, index = _a.index, total = _a.total;
                                            return o.next({
                                                type: "device-streaming",
                                                progress: progress,
                                                index: index,
                                                total: total
                                            });
                                        }
                                    })];
                            case 3:
                                signature = _a.sent();
                                operation = {
                                    id: (0, operation_1.encodeOperationId)(account.id, "", "OUT"),
                                    hash: "",
                                    type: "OUT",
                                    value: new bignumber_js_1.BigNumber(transaction.amount).plus(fee),
                                    fee: fee,
                                    blockHash: null,
                                    blockHeight: null,
                                    senders: Array.from(senders),
                                    recipients: recipients,
                                    accountId: account.id,
                                    date: new Date(),
                                    extra: {}
                                };
                                o.next({
                                    type: "signed",
                                    signedOperation: {
                                        operation: operation,
                                        signature: signature,
                                        expirationDate: null
                                    }
                                });
                                return [2 /*return*/];
                        }
                    });
                });
            }
            main().then(function () { return o.complete(); }, function (e) { return o.error(e); });
        });
    });
};
exports["default"] = signOperation;
//# sourceMappingURL=js-signOperation.js.map